import React from 'react';
import { Section } from './ui/Section';
export const MethodSection = () => {
  return <Section darker data-id="element-288">
      <div className="max-w-3xl mx-auto" data-id="element-289">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white text-center" data-id="element-290">
          Por qué el Método Apagón Mental es diferente a todo lo que probaste
        </h2>

        <div className="text-center mb-12" data-id="element-291">
          <span className="inline-block py-1 px-4 rounded-full bg-accent-blue/10 text-accent-light text-sm font-bold tracking-widest uppercase border border-accent-blue/20" data-id="element-292">
            EL MÉTODO APAGÓN MENTAL
          </span>
        </div>

        <h3 className="text-2xl font-serif text-center text-gray-200 mb-10" data-id="element-293">
          La única forma de apagar la cabeza que funciona en 2 pasos simples
        </h3>

        <div className="space-y-6 text-lg text-gray-300 mb-12" data-id="element-294">
          <p data-id="element-295">La mayoría de los métodos para dormir intentan una sola cosa:</p>
          <p className="text-xl font-medium text-white" data-id="element-296">Relajarte.</p>
          <p data-id="element-297">Y eso no alcanza.</p>
          <p data-id="element-298">Porque antes de relajarte, necesitás algo más importante.</p>
          <p className="text-white font-medium" data-id="element-299">
            Necesitás vaciar lo que te mantiene la cabeza encendida.
          </p>
          <p data-id="element-300">El Método Apagón Mental funciona en 2 partes:</p>
        </div>

        <div className="space-y-8 mb-12" data-id="element-301">
          <div className="bg-night-800 p-8 rounded-2xl border border-night-700 relative overflow-hidden" data-id="element-302">
            <div className="absolute top-0 left-0 w-2 h-full bg-accent-blue" data-id="element-303" />
            <h4 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-304">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-accent-blue/20 text-accent-light text-sm" data-id="element-305">
                1
              </span>
              PARTE 1: DESCARGA
            </h4>
            <p className="text-gray-300 text-lg mb-4" data-id="element-306">
              Sacás de tu cabeza todo lo que la sigue manteniendo prendida.
            </p>
            <p className="text-gray-400 mb-4 italic" data-id="element-307">
              Pendientes. Preocupaciones. Conversaciones que quedaron rebotando.
              Miedos. Todo afuera.
            </p>
            <p className="text-gray-300" data-id="element-308">
              Cuando tu cerebro siente que todo está registrado en algún lado,
              deja de repetírtelo. Baja la guardia.
            </p>
          </div>

          <div className="bg-night-800 p-8 rounded-2xl border border-night-700 relative overflow-hidden" data-id="element-309">
            <div className="absolute top-0 left-0 w-2 h-full bg-cta" data-id="element-310" />
            <h4 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-311">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-cta/20 text-cta text-sm" data-id="element-312">
                2
              </span>
              PARTE 2: APAGADO
            </h4>
            <p className="text-gray-300 text-lg mb-4" data-id="element-313">
              Una vez que descargaste, usás técnicas físicas simples para bajar
              el cuerpo.
            </p>
            <p className="text-gray-400 mb-4" data-id="element-314">
              Para frenar el espiral de pensamientos.
            </p>
            <p className="text-gray-300" data-id="element-315">
              Para darle al sistema nervioso la señal de que puede cambiar de
              modo alerta a modo descanso.
            </p>
          </div>
        </div>

        <div className="bg-night-900/50 p-8 rounded-2xl border border-night-700 text-center mb-10" data-id="element-316">
          <p className="text-2xl font-bold text-white mb-2" data-id="element-317">
            PRIMERO DESCARGÁS. DESPUÉS APAGÁS.
          </p>
          <p className="text-accent-light" data-id="element-318">
            Ese orden es el que hace que funcione.
          </p>
        </div>

        <div className="text-lg text-gray-300 leading-relaxed" data-id="element-319">
          <p data-id="element-320">
            <strong className="text-white" data-id="element-321">Por qué es diferente:</strong> La
            mayoría intenta apagar la cabeza sin descargarla primero. Es como
            intentar apagar un motor sin sacarle la nafta. El Método Apagón
            Mental hace las dos cosas. En el orden correcto.
          </p>
        </div>
      </div>
    </Section>;
};